import { useMutation, useQuery } from "@apollo/client";
import {
  CasesSendReportV1ActivityLogContainerSendReportCaseV1FieldsFragment,
  SendReportCaseV1ActivityLogInput,
  CasesSendReportV1ActivityLogContainerSendReportCaseV1Document,
  CasesSendReportV1ActivityLogContainerSendReportCaseV1UpdateDocument,
} from "../../../../../../generated";
import { ActivityLog } from "./activity-log";
import { message } from "antd";
import { ComponentQueryLoader } from "../../../../../shared/component-query-loader";

export interface ActivityLogDetailProps {
  caseId: string;
  isCaseOrApplicant: string;
}

export const ActivityLogContainer: React.FC<ActivityLogDetailProps> = (
  props
) => {
  const {
    data: activityLogData,
    loading: activityLogLoading,
    error: activityLogError,
  } = useQuery(
    CasesSendReportV1ActivityLogContainerSendReportCaseV1Document,
    {
      variables: {
        sendReportCaseV1Id: props.caseId,
      },
    }
  );

  const [activityLogAddUpdateActivity] = useMutation(CasesSendReportV1ActivityLogContainerSendReportCaseV1UpdateDocument);

  const handleAddUpdateActivity = async (
    values: SendReportCaseV1ActivityLogInput
  ) => {
    try {
      const { data } = await activityLogAddUpdateActivity({
        variables: {
          input: {
            id: props.caseId,
            activityLog: [...(activityLogData?.sendReportCaseV1?.activityLog?.map((a) => ({ id: a?.id })) ?? []), values]
          },
        },
      });
      if (data?.sendReportCaseV1Update?.status?.success) {
        message.success("Activity added successfully");
      } else {
        message.error(
          `Error adding activity : ${data?.sendReportCaseV1Update?.status?.errorMessage}`
        );
      }
    } catch (error) {
      message.error(
        `Error adding activity : ${JSON.stringify(error)}`
      );
    }
  };

  return (
    <ComponentQueryLoader
      loading={activityLogLoading}
      error={activityLogError}
      hasData={activityLogData?.sendReportCaseV1}
      hasDataComponent={
        <ActivityLog
          data={activityLogData?.sendReportCaseV1 as CasesSendReportV1ActivityLogContainerSendReportCaseV1FieldsFragment}
          onAddUpdateActivity={handleAddUpdateActivity}
          isCaseOrApplicant={props.isCaseOrApplicant}
        />
      }

    />
  );
};
